module.exports = __webpack_public_path__ + "img/marker_maps.2cd53c8d.png";